import { createAsyncThunk } from "@reduxjs/toolkit";

import { noAuthInstance as axios } from "../../../api/axiosInstance";

type resetData = {
  email: string;
  token: string;
}

export const validateToken = createAsyncThunk(
  "validateToken",
  async(resetData: resetData, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    const email = resetData.email;
    const token = resetData.token;

    if (!email || !token) {
      return rejectWithValue("Oops! Please try again. Your email or token is incorrect.");
    }

    const payload = {
      email,
      token
    };

    return axios.post("/api/v1/auth/validate-token", payload)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        if (error.response.data?.status === 404) {
          return rejectWithValue("Oops! Please try again. Either your email or password are incorrect.");
        }

        if (error.response && error.response.data) {
          return rejectWithValue(error.response.data.detail);
        }

        return rejectWithValue("Please try again later, we're experiencing a server error. We're working on it!");
      });
  }
);
